import { colors, darkColors } from './colors';
import { typography, textStyles } from './typography';
import { spacing, borderRadius, shadows } from './spacing';

export const lightTheme = {
  colors,
  typography,
  textStyles,
  spacing,
  borderRadius,
  shadows,
  isDark: false,
} as const;

export const darkTheme = {
  colors: darkColors,
  typography,
  textStyles,
  spacing,
  borderRadius,
  shadows,
  isDark: true,
} as const;

export type Theme = typeof lightTheme;

export const theme = lightTheme; // Default theme

// Component-specific theme tokens
export const componentTokens = {
  button: {
    height: {
      sm: 32,
      md: 40,
      lg: 48,
    },
    padding: {
      sm: { horizontal: spacing[3], vertical: spacing[2] },
      md: { horizontal: spacing[4], vertical: spacing[3] },
      lg: { horizontal: spacing[6], vertical: spacing[4] },
    },
    borderRadius: borderRadius.md,
  },
  input: {
    height: {
      sm: 32,
      md: 40,
      lg: 48,
    },
    padding: {
      horizontal: spacing[3],
      vertical: spacing[2],
    },
    borderRadius: borderRadius.md,
    borderWidth: 1,
  },
  card: {
    padding: spacing[4],
    borderRadius: borderRadius.lg,
    shadow: shadows.md,
  },
  modal: {
    borderRadius: borderRadius.xl,
    padding: spacing[6],
    shadow: shadows.xl,
  },
  avatar: {
    size: {
      xs: 24,
      sm: 32,
      md: 40,
      lg: 48,
      xl: 64,
      '2xl': 80,
    },
    borderRadius: borderRadius.full,
  },
  badge: {
    padding: {
      horizontal: spacing[2],
      vertical: spacing[1],
    },
    borderRadius: borderRadius.full,
    fontSize: typography.fontSize.xs,
  },
} as const;
